import {flagSvg as Icon__small__flagSvg} from '../Icon__small/Icon__small--flag.js'

export var flag = {
  name: 'flag',
  category: 'icon',
  colorable: true,
  svg: Icon__small__flagSvg,
};
